export default "__VITE_ASSET__BYoW$21x__"